import { http } from '@/providers/apis/http';
import { profileSerializer } from '@/providers/serializers/profile/profile';
import { User } from '@/models/profile/user';
export class ProfileAPI {

  private static INSTANCE = new ProfileAPI();

  static get instance() {
    return this.INSTANCE;
  }

  private namespace: string = 'api/nucleus/v2';

  private lookupName: string = 'api/nucleus/v1/lookups';

  private mcNamespace: string = 'api/missioncontrol/v1';

  public fetchUserProfiles<T>(userIds: any): Promise<User[]> {
    const endpoint = `${this.namespace}/profiles/search`;
    const headers = http.getTokenHeaders();
    const params = {
      userids: userIds,
    };
    return http.get(endpoint, headers, params).then((response) => {
      return profileSerializer.serializeUserProfiles(response.data);
    });
  }

  public getTenantSettings() {
    const endpoint = `${this.lookupName}/tenant-settings`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });
  }

  public fetchDok() {
    const endpoint = `${this.lookupName}/dok`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });
  }

  public updateUserPreference(params: any) {
    const endpoint = `${this.mcNamespace}/user/preference`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, params).then((response) => {
      return response.data;
    });
  }

  public fetchUserPreference(userId: string) {
    const endpoint = `${this.mcNamespace}/user/preference?user_id=${userId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data.learnerPreference;
    });
  }

}

export const profileAPI = ProfileAPI.instance;
